import { BaseService, api } from "./common/base";

export class UserService extends BaseService<any> {
  constructor() {
    super("user");
  }

  public create({ user }) {
    return api.post(`/user`, user).then((res) => res.data);
  }

  public getStatistics(params: any) {
    return api.get(`/user/get-statistics`, { params }).then((res) => res.data);
  }

  async sendChallenge2MR(isRegistering = false) {
    return api
      .post(`/user/current/send-challenge-2mr`, {
        isRegistering,
      })
      .then((res) => res.data);
  }

  public getCurrentUser() {
    return api.get(`/user/current`).then((res) => res.data);
  }

  public createChannel({
    userIds,
    channelType,
    title,
  }: {
    userIds: string[];
    channelType: string;
    title?: string;
  }) {
    return api
      .post(`/user/channels`, { userIds, channelType, title })
      .then((res) => res.data);
  }

  public patchCurrent({ user }) {
    return api.patch(`/user/current`, user).then((res) => res.data);
  }

  public setCurrentPosition({ latitude, longitude }) {
    return api
      .patch(`/user/current/position`, { latitude, longitude })
      .then((res) => res.data);
  }
  public patchCurrentPreferences(
    preferences: { code: string; valueString: string }[]
  ) {
    return api
      .patch(`/user/current/preferences`, { preferences })
      .then((res) => res.data);
  }

  public getSignupJWT() {
    return this._post(`current/seald-signup-jwt`);
  }

  public updateDeviceToken(payload) {
    return api
      .patch(`/user/current/device-token`, payload)
      .then((res) => res.data);
  }
}
